import React from 'react';

const EventCarouselCard = ({ event }) => {
  const getEventTypeLabel = (category) => {
    switch (category) {
      case 'webinar':
        return 'Webinar Series';
      case 'competitions':
        return 'Competitions';
      case 'events':
        return 'Event Series';
      default:
        return 'Event';
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'webinar':
        return 'bg-Color-Brand';
      case 'competitions':
        return 'bg-Color-Brand-Purple';
      case 'events':
        return 'bg-Color-Brand-Green';
      default:
        return 'bg-Color-Primary';
    }
  };

  return (
    <div className="rounded-none overflow-hidden shadow-2xl bg-Color-White flex flex-col w-full h-full max-w-[600px] max-h-[360px]" style={{ aspectRatio: '5/3' }}>
      {/* Banner Image - Main focus */}
      <div className="relative w-full overflow-hidden bg-gradient-to-br from-Color-Foreground to-gray-200 flex-shrink-0" style={{ height: '72%' }}>
        <img
          src={event.flyerImage || event.image}
          alt={event.title}
          className="w-full h-full object-cover"
          draggable="false"
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/800x600?text=Event+Image';
          }}
        />
      </div>

      {/* Event Title and Type Section - Bottom */}
      <div className="px-2 sm:px-3 md:px-numbers-16 py-2 sm:py-2.5 md:py-numbers-12 bg-Color-White flex flex-col justify-between overflow-hidden flex-1">
        <h3 className="text-xs sm:text-sm md:text-base font-bold text-Color-Black font-['Montserrat'] leading-snug line-clamp-2 mb-1 sm:mb-1.5 md:mb-numbers-8">
          {event.title}
        </h3>
        
        {/* Event Type Ribbon - Bottom */}
        <div className="flex items-center mt-auto">
          <span className={`${getCategoryColor(event.category)} text-Color-White text-[9px] sm:text-[10px] md:text-xs font-semibold font-['Montserrat'] px-2 sm:px-2.5 md:px-numbers-12 py-1 sm:py-1.25 md:py-1.5 rounded uppercase tracking-wide`}>
            {getEventTypeLabel(event.category)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default EventCarouselCard;
